export default __webpack_public_path__ + "static/media/calender-active.6745d41d.svg";